import { render, staticRenderFns } from "./StudentVocabulary.vue?vue&type=template&id=3ae2303c&scoped=true&"
import script from "./StudentVocabulary.vue?vue&type=script&lang=js&"
export * from "./StudentVocabulary.vue?vue&type=script&lang=js&"
import style0 from "./StudentVocabulary.vue?vue&type=style&index=0&id=3ae2303c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2303c",
  null
  
)

export default component.exports